<ngx-l2-multi-org-menu>
  <mat-tab-nav-panel #pageTabPanel class="w-100 flex-grow-1">
    @if (isRequested) {
      @if (invitations && invitations.length > 0) {
        <app-multi-domain-start [invitations]="invitations"
                                (onAcceptInvitation)="acceptInvitation($event)"
                                (onRejectInvitation)="rejectInvitation($event)"
                                (onCreateDomain)="onDomainCreationNotAllowed()"/>
      } @else if (domains.length > 0) {
        <div class="back-btn">
          <button mat-button (click)="openHcp()">
            <mat-icon class="material-icons-rounded">arrow_back</mat-icon>
            {{ 'MULTI_DOMAIN.BACK_TO_DASHBOARD'|translate }}
          </button>
        </div>
        <h1 class="page-headline mb-4">{{ "MULTI_DOMAIN.TITLE" | translate }}</h1>
        <app-multi-domain-list [domains]="domains" (onCreateDomain)="showDomainCreate()"></app-multi-domain-list>
      } @else {
        <app-multi-domain-start [invitations]="[]" (onCreateDomain)="showDomainCreate()" />
      }
    }
  </mat-tab-nav-panel>
</ngx-l2-multi-org-menu>
